import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // load translation using http -> see /public/locales
  .use(Backend)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  .init({
    // All locale codes used in /public/locales/ — only these will be fetched.
    // nonExplicitSupportedLngs maps browser locales like "en-US" → "US" automatically.
    supportedLngs: ["US", "PT", "SP", "CZ", "FI", "RO", "BG", "IT", "HR", "LT", "DE", "FR", "EL", "TR"],
    nonExplicitSupportedLngs: false,

    fallbackLng: "US",
    // Use full language codes as-is (our locales use uppercase country codes, not BCP-47)
    load: "currentOnly",

    debug: false,

    interpolation: {
      escapeValue: false,
    },

    // Keep useSuspense false; components handle missing keys gracefully.
    react: { useSuspense: false },

    detection: {
      // Prefer the language stored by the app over browser locale.
      // Browser locale (en-US) does not match our locale keys (US, FR…).
      order: ["localStorage", "querystring"],
      caches: ["localStorage"],
    },
  });

export default i18n;
